export default "__VITE_ASSET__108e68ba__"